module.exports = __webpack_public_path__ + "img/untersuchung1.8c2880bc.jpg";